<div class="row">
  @if (contextVisible) {
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-10">
      <p-select [options]="contexts" [(ngModel)]="selectedContext" optionLabel="Description" optionValue="ID"
                  [disabled]="contextDisabled" [class]="'full-width'" (onChange)="updateContext()">
      </p-select>
    </div>
  }
  @switch (selectedContext) {
    @case ('MEMBERSHIP') {
      @if (tcORGDROPDOWNDISPLAY) {
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-10">
          <p-select [options]="orgMNames" [(ngModel)]="selectedMOrgId" [optionLabel]="tcORGDROPDOWNDISPLAY"
                      optionValue="ID" [filter]="true" [filterBy]="tcORGDROPDOWNDISPLAY"
                      showClear="true" placeholder="Select a Perspective" [class]="'full-width'"
                      (onChange)="updatePerspective()">
            @switch (tcORGDROPDOWNDISPLAY) {
              @case ('Description') {
                <ng-template let-orgs pTemplate="orgs">
                  <div class="org-names">
                    <div [ngClass]="'level-'+orgs.Level" [pTooltip]="orgs.Description"
                         tooltipPosition="bottom">{{ orgs.Description }}
                    </div>
                  </div>
                </ng-template>
              }
              @case ('Abbreviation') {
                <ng-template let-orgs pTemplate="orgs">
                  <div class="org-names">
                    <div [ngClass]="'level-'+orgs.Level" [pTooltip]="orgs.Description"
                         tooltipPosition="bottom">{{ orgs.Abbreviation }}
                    </div>
                  </div>
                </ng-template>
              }
            }
          </p-select>
        </div>
      }
    }
    @case ('TRAINING') {
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-10">
        <p-select [options]="orgTNames" [(ngModel)]="selectedTOrgId" optionLabel="Description" optionValue="ID"
                    [filter]="true" filterBy="Description"
                    showClear="true" placeholder="Select a Perspective" [class]="'full-width'"
                    (onChange)="updatePerspective()">
          <ng-template let-orgs pTemplate="orgs">
            <div class="org-names">
              <div [ngClass]="'level-'+orgs.Level" pTooltip="{{orgs.Description}}">{{ orgs.Description }}</div>
            </div>
          </ng-template>
        </p-select>
      </div>
    }
    @case ('ORGANIZE') {
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-10">
        <p-select [options]="orgMNames" [(ngModel)]="selectedOOrgId" optionLabel="Description" optionValue="ID"
                    [filter]="true" filterBy="Description"
                    showClear="true" placeholder="Select a Perspective" [class]="'full-width'"
                    (onChange)="updatePerspective()">
          <ng-template let-orgs pTemplate="orgs">
            <div class="org-names">
              <div [ngClass]="'level-'+orgs.Level" pTooltip="{{orgs.Description}}">{{ orgs.Description }}</div>
            </div>
          </ng-template>
        </p-select>
      </div>
    }
  }
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-align-right">
    <p-button (click)="close()" icon="pi pi-times" ></p-button>
  </div>
</div>
